import isEmpty from "lodash-es/isEmpty";
import type { AppProps } from "next/app";
import type { FC, PropsWithChildren } from "react";

import { useRouteParams } from "~/data/route";

import { AppActorContext } from "./app.machine";

export const AppActorProvider: FC<
	PropsWithChildren<{
		pageProps?: AppProps["pageProps"];
	}>
> = ({ children, pageProps }) => {
	const { workspaceName: workspaceNameParams, documentId: documentIdParams } = useRouteParams();

	const documentId = pageProps?.documentId || documentIdParams || "";
	const workspaceName = pageProps?.workspaceName || workspaceNameParams || "";

	return (
		<AppActorContext.Provider
			options={{
				input: isEmpty(documentId)
					? undefined
					: {
							documents: {
								[documentId]: {
									id: documentId,
									title: documentId,
									createdAt: new Date(0),
									updatedAt: new Date(0),
									template: false,
									workspaces: [
										{
											id: workspaceName,
											name: workspaceName,
											slug: workspaceName,
											host: "",
											owner: false,
											role: "guest",
										},
									],
								},
							},
						},
			}}
		>
			{children}
		</AppActorContext.Provider>
	);
};
